import styled from "styled-components";

export const Container = styled.label`
  display: flex;
  width: fit-content;
  gap: 0 8px;
  align-items: center;
  cursor: pointer;
  position: relative;

  > span {
    margin-left: 8px;
    color: #9d9d9d;
    font-family: Mulish;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }

  &::after {
    display: block;
    content: url("/assets/svgs/icon-check.svg");
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-45%);
  }

  &:has(> input:checked) {
    &::after {
      content: url("/assets/svgs/icon-check-true.svg");
    }
  }

  &:has(> input:disabled) {
    opacity: 0.6;
  }
`;

export const MyInput = styled.input`
  opacity: 0;
`;
